import {sleep, useMock} from "../utils/helpers";
import http from '../plugins/http';
import config from '../config';

const orderUri = config.services.order;
const ratingUri = config.services.rating;

class Orders {
  constructor() {
    this.useMock = useMock('orders');
  }

  async fetchOrders() {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(200);
        resolve((await import('../../mock/orders.js')));
      });
    }
  }

  async getOrdersList(filter) {
    const params = {};
    params.limit = filter.limit || 25;
    params.page = filter.page || 1;

    const {data} = await http.get(`${ratingUri}/api/v1/user/orders/list`, { params });

    return data.data;
  }

  async createOrder(order) {
    let orderData = {
      amount:        order.coin.amount,
      currencyToBuy: order.coin.symbol.toUpperCase(),
      moneyCurrency: order.currency
    }

    return new Promise(async resolve => {
      // if(this.useMock) {
      //   await sleep(2000);
      //   resolve({
      //     amount: 186,
      //     currencyToBuy: "BTC",
      //     item: 0.04743389,
      //     moneyCurrency: "USD",
      //     orderId: 43163,
      //     orderStatus: "Open"
      //   });

      //   return;
      // }

      const {data} = await http.post(`${orderUri}/api/v1/orders/`, orderData);
      resolve(data);
    });
  }

  async paymentInfo(orderId) {

    return new Promise(async resolve => {
      // if(this.useMock) {
      //   resolve({
      //     accountNumber: "",
      //     address: "1",
      //     beneficiary: "1",
      //     currencyToBuy: "BTC",
      //     finalPayment: 190.5,
      //     iban: "1",
      //     item: 0.04743389,
      //     moneyCurrency: "USD",
      //     name: "BankUSD1",
      //     orderId: 43163,
      //     paymentMethod: "wire_transfer",
      //     paymentMethodFee: 4.5,
      //     price: 177.63,
      //     rate: 3744.791,
      //     serviceFee: 8.37,
      //     swift: "1"
      //   });
      // }
      
      let {data} = await http.get(`${orderUri}/api/v1/orders/${orderId}/paymentinfo`);
      resolve(data)
    });
  }




}

export default new Orders();



// WEBPACK FOOTER //
// ./src/services/orders.js